import React, { createContext, useContext, useMemo, useState, ReactNode } from 'react';

type HideEmptyColumnsContextType = {
  hideEmptyColumns: boolean;
  setHideEmptyColumns: (value: boolean) => void;
};

const HideEmptyColumnsContext = createContext<HideEmptyColumnsContextType | undefined>(
  undefined,
);

export const HideEmptyColumnsProvider = ({ children }: { children: ReactNode }) => {
  const [hideEmptyColumns, setHideEmptyColumns] = useState(false);

  const contextValue = useMemo(
    () => ({
      hideEmptyColumns,
      setHideEmptyColumns,
    }),
    [hideEmptyColumns],
  );

  return (
    <HideEmptyColumnsContext.Provider value={contextValue}>
      {children}
    </HideEmptyColumnsContext.Provider>
  );
};

export function useHideEmptyColumns() {
  const ctx = useContext(HideEmptyColumnsContext);
  if (!ctx) {
    throw new Error('useHideEmptyColumns must be used within HideEmptyColumnsProvider');
  }
  return ctx;
}
